import { ICommand, ICommandResult } from '../types/commands';
import { commandDispatcher } from '../commandDispatcher';
/*import { send as sendToOtherClients } from '@/_core/fluxstore/realtimeService';*/
import { snackbar } from '@/_core/app-components/use';
import { createDebugger } from '@/_core/utils/debug';
const debug = createDebugger('cqrs:useSendCommand');

export async function useSendCommand<TCommandResult extends ICommandResult>(
    action: any,
    options: {
        createCommand: () => ICommand<TCommandResult>;
        isCurrent?: () => boolean;
        onSuccess?: (res: TCommandResult) => void;
        onError?: (message: string) => boolean;
    }
): Promise<boolean> {
    if (action.isDispatchedByRealTimeCallback === true) {
        return true;
    }

    const { createCommand, onSuccess, onError } = options;

    const cm = createCommand();
    if (options.isCurrent && !options.isCurrent()) return false;
    try {
        const res = await (options.isCurrent
            ? commandDispatcher.dispatchCommand(cm, options.isCurrent)
            : commandDispatcher.dispatchCommand(cm));
        if (options.isCurrent && !options.isCurrent()) return false;
        if (res == null) {
            return false;
        }
        if (res.IsSuccess) {
            if (onSuccess) {
                onSuccess(res);
            }
            return true;
        } else {
            if (onError) {
                return onError(res.Message);
            } else {
                snackbar.showError(res.Message);
            }
            return false;
        }
    } catch (error) {
        if (options.isCurrent && !options.isCurrent()) return false;
        if (onError) {
            onError((error as Error).message);
        } else {
            snackbar.showError((error as Error).message);
        }
        throw error;
    } finally {
        //app.loader.hide()....
    }
}

export async function useSendCommandAsync<TCommandResult extends ICommandResult>(
    action: any,
    options: {
        createCommand: () => Promise<ICommand<TCommandResult>>;
        isCurrent?: () => boolean;
        /** Only for void commands whose successful HTTP response contains JSON null. */
        acceptNullResult?: boolean;
        onSuccess?: (res: TCommandResult) => void;
        onError?: (message: string) => boolean;
    }
): Promise<boolean> {
    if (action.isDispatchedByRealTimeCallback === true) {
        return true;
    }

    const { createCommand, onSuccess, onError } = options;

    const cm = await createCommand();
    if (options.isCurrent && !options.isCurrent()) return false;
    try {
        debug('useSendCommandAsync dispatchCommand', cm);
        const res = await (options.isCurrent
            ? commandDispatcher.dispatchCommand(cm, options.isCurrent)
            : commandDispatcher.dispatchCommand(cm));
        if (options.isCurrent && !options.isCurrent()) return false;
        debug('useSendCommandAsync dispatchCommand end', cm);
        if (res == null) {
            return res === null && options.acceptNullResult === true;
        }
        if (res.IsSuccess) {
            if (onSuccess) {
                onSuccess(res);
            }
            return true;
        } else {
            if (onError) {
                return onError(res.Message);
            } else {
                snackbar.showError(res.Message);
            }
            return false;
        }
    } catch (error) {
        if (options.isCurrent && !options.isCurrent()) return false;
        if (onError) {
            onError((error as Error).message);
        } else {
            snackbar.showError((error as Error).message);
        }
        throw error;
    } finally {
        //app.loader.hide()....
    }
}
/*export async function useSendCommandAnDispatchAction<TCommandResult extends ICommandResult>(
    action: any,
    options: {
        createCommand: () => ICommand<TCommandResult>;
        onSuccess?: (res: TCommandResult) => void;
        onError?: (message: string) => void;
    }
): Promise<void> {
    if (action.isDispatchedByRealTimeCallback == true) {
        //debug('realtim volt ezért vissza is tért...', action.isDispatchedByRealTimeCallback);
        return;
    }

    const { createCommand, onSuccess, onError } = options;

    const cm = createCommand();
    try {
        const res = await commandDispatcher.dispatchCommand(cm);
        if (res.IsSuccess) {
            if (onSuccess) {
                onSuccess(res);
            }
            sendToOtherClients(action);
            return;
        } else {
            if (onError) {
                onError(res.Message);
            }
            return;
        }
    } catch (error) {
        if (onError) {
            onError(error.message);
        } else {
            snackbar.showError(error.Message);
        }
        throw error;
    } finally {
        //app.loader.hide()....
    }
}*/
